module.exports = __webpack_public_path__ + "facelifting_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_1_before.jpg
// module id = 1050
// module chunks = 0